import { i18nLocale } from '@weavix/models/src/translate/translate';
import { listenerLanguages, speaksAnyOf } from '@weavix/domain/src/translate/listener-languages';
import { myUser, usersContext } from './users-store';

/** The logged-in user's languages (primary, English when unset, then secondary); none until their record loads. */
export function myLanguages(): i18nLocale[] {
    const user = usersContext.getDefault() ? myUser() : undefined;
    return user ? listenerLanguages(user.locale, user.secondaryLocale) : [];
}

/** Whether any of `languages` (locales or full languages like `es-MX`) is one of mine, compared by language subtag. */
export function speaksMyLanguage(...languages: Array<string | null | undefined>): boolean {
    return speaksAnyOf(myLanguages(), ...languages);
}
